import { useMemo, useState } from "react";
import { comics, genres } from "@/mocks/comics";
import ComicCard from "./ComicCard";
import SectionHeader from "./SectionHeader";

const filterTabs = ["全部", "恋爱", "奇幻", "校园", "悬疑"];

export default function Categories() {
  const [active, setActive] = useState("全部");

  const filtered = useMemo(() => {
    if (active === "全部") return comics.slice(0, 8);
    return comics.filter((c) => c.genre === active).slice(0, 8);
  }, [active]);

  return (
    <section id="categories" className="w-full bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="漫画分类"
          title="题材分类，精准找到你的心头好"
          desc="恋爱、奇幻、校园、悬疑等热门题材分类齐全，点击下方标签即可切换浏览，快速定位你偏爱的漫画风格。"
          link="#hot"
          linkLabel="浏览更多热门作品"
        />

        <div className="mb-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {genres.map((g) => (
            <button
              key={g.key}
              type="button"
              onClick={() => setActive(g.name)}
              className={`group flex items-start gap-3 rounded-lg border bg-background-50 p-4 text-left transition-all hover:-translate-y-0.5 ${
                active === g.name
                  ? "border-primary-300 ring-2 ring-primary-200"
                  : "border-background-200 hover:border-primary-200"
              }`}
              aria-pressed={active === g.name}
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-xl text-white ${
                  g.color === "primary"
                    ? "bg-primary-500"
                    : g.color === "accent"
                      ? "bg-accent-500"
                      : "bg-secondary-500"
                }`}
              >
                <i className={g.icon} aria-hidden="true" />
              </span>
              <span>
                <span className="flex items-center gap-2">
                  <span className="font-heading text-lg text-foreground-950">{g.name}</span>
                  <span className="text-xs text-foreground-400">{g.count}</span>
                </span>
                <span className="mt-0.5 block text-sm font-medium text-primary-600">{g.tagline}</span>
                <span className="mt-1 block text-xs leading-relaxed text-foreground-600">{g.desc}</span>
              </span>
            </button>
          ))}
        </div>

        <div className="mb-6 flex flex-wrap items-center gap-2">
          <span className="text-sm font-semibold text-foreground-800">当前浏览：</span>
          {filterTabs.map((tab) => (
            <button
              key={tab}
              type="button"
              onClick={() => setActive(tab)}
              className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                active === tab
                  ? "bg-primary-500 text-white"
                  : "bg-background-200 text-foreground-700 hover:bg-background-300"
              }`}
              aria-pressed={active === tab}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
          {filtered.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}